import { useEffect, useRef, useState } from 'react'
import PageTitle from '../../../../components/partials/PageTitle'
import ReportFilter from '../CustomerReport/ReportFilter';
import { useSelector } from 'react-redux';
import { getIndividualSavingsReport } from '../../../../redux/slice/report/reportSlice';
import { useDispatch } from 'react-redux';
import { CSVLink } from 'react-csv';
import excel from "../../../../assets/images/img-icons/excel.png";
import pdf from "../../../../assets/images/img-icons/pdf.png";
import { useReactToPrint } from 'react-to-print';

const SavingsInformationReport = () => {

  const CCPdfRef = useRef();

  const dispatch = useDispatch()

    const [filterData, setFilterData] = useState();
    const [filteredItem, setFilteredItem] = useState(false);

    const {customerOverviewData} = useSelector((state) => state.report);
    const { user } = useSelector((state) => state.auth);

    const breadcrumb = {
        from: {
          title: "Savings Policy Report",
          link: "/admin/reports/savings-policy-report",
        },
        current: {
          title: "Savings Policy Information Report",
          link: null,
        },
    };

    const generatePDF = useReactToPrint({
      content: () => CCPdfRef.current,
      documentTitle: "Savings Policy Information Report",
    });

    const processedData = customerOverviewData?.map(row => {
      const fullName = `${row.first_name} ${row.last_name}`;
      const agent = `${row.agent_firstname} ${row.agent_lastname}`;
  
      return { ...row, full_name: fullName, agent }; // Modify status property while keeping the rest
    }); 

    const headers = [
      { label: 'Policy ID', key: 'policy_id' },
      { label: 'Customer Name', key: 'full_name' },
      { label: 'Policy', key: 'Policy_name' },
      { label: 'Sum Insured', key: 'sum_assured' },
      { label: 'Total Contribution', key: 'total_contribution' },
      { label: 'Effective Date', key: 'effective_date' },
      { label: 'End Date', key: 'end_date' },
      { label: 'Agent', key: 'agent' },
      { label: 'Office', key: 'office_name' },
    ];

    const totalSumAssured = customerOverviewData?.reduce((total, item) => {
      return total + (parseFloat(item?.sum_assured) || 0);
    }, 0);
    const totalContribution = customerOverviewData?.reduce((total, item) => {
      return total + (parseFloat(item?.total_contribution) || 0);
    }, 0);

    useEffect(() => {
      if (filteredItem) {
        if (filterData.office_id === '') {
          const updatedFilterData = {
            ...filterData,
            office_id: user?.user?.office_id
          };
          dispatch(getIndividualSavingsReport(updatedFilterData));
        }else{
          dispatch(getIndividualSavingsReport(filterData));
        }
      }
    }, [dispatch, filterData, filteredItem, user?.user?.office_id])

  return (
    <div>
        {/* page title */}
        <PageTitle title='Savings Policy Information Report' breadcrumb={breadcrumb} />
        {/* end page title */}
        <div className='row card p-1' style={{ margin: "auto 1px" }}>
            <ReportFilter
                page={"savingsInfo"}
                setFilterData={setFilterData}
                setFilteredItem={setFilteredItem}
                filteredItem={filteredItem}
            />
            {customerOverviewData && (
                  <div className='row mb-3'>
                    <>
                      <div className='d-flex justify-content-end align-items-center'>
                        <div className=' d-flex align-items-center border '>
                          <span
                            className='bg-info me-2 text-white'
                            style={{ padding: "3px" }}
                          >
                            Export to
                          </span>
        
                          <span
                            href='#'
                            id='btnExport'
                            className='me-1 cursor-p'
                            title='Export to Pdf'
                            onClick={generatePDF}
                          >
                            <img
                              src={pdf}
                              alt='export-pdf'
                              style={{ height: "25px" }}
                            />
                          </span>
                          {customerOverviewData ? (
                            <CSVLink
                              data={processedData}
                              headers={headers}
                              style={{ fontWeight: "bolder", cursor: "pointer" }}
                              filename='IndividualSavingsReport'
                            >
                              <span
                                href='#'
                                id='btnExport'
                                className='mr-1'
                                title='Export to Excel'
                              >
                                <img
                                  src={excel}
                                  alt='export-excel'
                                  style={{ height: "25px", marginRight: "5px" }}
                                />
                              </span>
                            </CSVLink>
                          ) : null}
                        </div>
                      </div>
                      <div className='table-responsive'>
                      <table
                  className='table table-centered table-striped nowrap w-100 no-footer'
                  ref={CCPdfRef}
                >
                  <thead>
                    <tr>
                      <th
                        className='sorting'
                        tabIndex='0'
                        rowSpan='1'
                        colSpan='1'
                        style={{ width: "100.8px" }}
                        aria-label='Email: activate to sort column ascending'
                      >
                        Policy Id
                      </th>
                      <th
                        className='sorting'
                        tabIndex='0'
                        rowSpan='1'
                        colSpan='1'
                        style={{ width: "150.8px" }}
                        aria-label='Customer: activate to sort column ascending'
                      >
                        Customer Name
                      </th>
                      <th
                        className='sorting'
                        tabIndex='0'
                        rowSpan='1'
                        colSpan='1'
                        style={{ width: "134.8px" }}
                        aria-label='Phone: activate to sort column ascending'
                      >
                        Policy
                      </th>
                      <th
                        className='sorting'
                        tabIndex='0'
                        rowSpan='1'
                        colSpan='1'
                        style={{ width: "134.8px" }}
                        aria-label='Phone: activate to sort column ascending'
                      >
                        Sum Insured
                      </th>
                      <th
                        className='sorting'
                        tabIndex='0'
                        rowSpan='1'
                        colSpan='1'
                        style={{ width: "124.8px" }}
                        aria-label='Phone: activate to sort column ascending'
                      >
                        Total Contribution
                      </th>
                      <th
                        className='sorting'
                        tabIndex='0'
                        rowSpan='1'
                        colSpan='1'
                        style={{ width: "120.8px" }}
                        aria-label='Status: activate to sort column ascending'
                      >
                        Effective Date
                      </th>
                      <th
                        className='sorting'
                        tabIndex='0'
                        rowSpan='1'
                        colSpan='1'
                        style={{ width: "120.8px" }}
                        aria-label='Status: activate to sort column ascending'
                      >
                        End Date
                      </th>
                      <th
                        className='sorting'
                        tabIndex='0'
                        rowSpan='1'
                        colSpan='1'
                        style={{ width: "120.8px" }}
                        aria-label='Status: activate to sort column ascending'
                      >
                        Agent
                      </th>
                      <th
                        className='sorting'
                        tabIndex='0'
                        rowSpan='1'
                        colSpan='1'
                        style={{ width: "120.8px" }}
                        aria-label='Status: activate to sort column ascending'
                      >
                        Office
                      </th>
                    </tr>
                  </thead>
                  {customerOverviewData?.length ? (
                    <tbody>
                      {customerOverviewData?.map((item, i) => (
                        <tr key={i}>
                          <td className='text-dark'>{item?.policy_id}</td>
                          <td className='table-user'>
                            <span className='text-body fw-semibold'>
                              {item?.first_name} {item?.last_name}
                            </span>
                          </td>
                          <td className='table-user'>{item?.Policy_name}</td>
                          <td className='table-user'>{parseFloat(item?.sum_assured).toLocaleString(2)}</td>
                          <td className='table-user'>{parseFloat(item?.total_contribution).toLocaleString(2)}</td>
                          <td className='table-user'>{item?.effective_date}</td>
                          <td className='table-user'>{item?.end_date}</td>
                          <td>
                            {item?.agent_firstname && item?.agent_firstname + " "}
                            {item?.agent_lastname && item?.agent_lastname}
                          </td>
                          <td>{item?.office_name}</td>
                        </tr>
                      ))}
                      <tr>
                        <td colSpan="3" className="text-end fw-bold">
                          Total:
                        </td>
                        <td className="fw-bold">{totalSumAssured.toLocaleString(2)}</td>
                        <td className="fw-bold">{totalContribution.toLocaleString(2)}</td>
                        <td colSpan="4"></td>
                      </tr>
                    </tbody>
                  ) : null}
                </table>
                        {customerOverviewData?.length < 1 ? (
                          <h5 className='alert alert-info'>No result found!</h5>
                        ) : null}
                      </div>
                    </>
                  </div>
                )}
        </div>
    </div>
  )
}

export default SavingsInformationReport